export default __webpack_public_path__ + "static/pa-photo-d0f7b5cd00c32e5f489e46072e455038.jpg";